import styles from './styles.module.scss';

type InputLabelProps = {
  children?: React.ReactNode;
};

const InputLabel: React.FC<InputLabelProps> = (props) => {
  const { children } = props;

  return <div className={styles.label}>{children}</div>;
};

export default InputLabel;
